import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraFilterToolbar } from '../captains/filter-toolbar';
import { PADDING } from './page-padding';
/** Standard header, controls, collection, and pagination layout for record lists. */ export const SpecraListPage = /*#__PURE__*/ React.forwardRef(({ children, className, footer, header, padding = 'default', toolbar, toolbarProps, ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: cn('mx-auto w-full max-w-7xl space-y-4 sm:space-y-5', PADDING[padding], className),
        ref: ref,
        ...props,
        children: [
            header,
            toolbarProps ? /*#__PURE__*/ _jsx(SpecraFilterToolbar, {
                ...toolbarProps
            }) : toolbar,
            /*#__PURE__*/ _jsx("div", {
                className: "min-w-0",
                children: children
            }),
            footer
        ]
    }));
SpecraListPage.displayName = 'SpecraListPage';
